import Spacer from '@/common/components/spacer';
import { Skeleton } from '@/shadcn-ui/skeleton';
import EstimatedPricing from './estimated-pricing';
import { PackageSummary } from '@/catalog/hooks/use-package-summary';

interface PDPStickyBarTextProps {
  isLoading?: boolean;
  hasNoSelectedAgeCreditRange?: boolean;
  packageSummary?: PackageSummary;
  handleSavingsClick?: () => void;
}

export default function PDPStickyBarText({
  isLoading,
  hasNoSelectedAgeCreditRange,
  packageSummary,
  handleSavingsClick,
}: PDPStickyBarTextProps) {
  if (isLoading) {
    return (
      <div className="flex flex-col">
        <Skeleton className="h-4 w-[220px]" />
        <Spacer variant="height8" />
        <Skeleton className="h-4 w-[200px] self-end" />
      </div>
    );
  }

  if (hasNoSelectedAgeCreditRange) {
    return (
      <p className="body2-tight w-1/2 flex-shrink-0 text-flexcar-neutral50">
        Select age & credit score
      </p>
    );
  }

  if (!packageSummary) {
    return (
      <p className="body2-tight w-1/2 flex-shrink-0 text-flexcar-neutral50">
        Choose plans to see monthly total
      </p>
    );
  }

  return (
    <EstimatedPricing
      estimatedMonthlyCostCopy={packageSummary?.estimatedMonthlyCostCopy || ''}
      estimatedMonthlySavingsCopy={packageSummary?.estimatedSavingsCopy}
      onClickDelegate={handleSavingsClick}
    />
  );
}
